module.exports = new __parcel__URL__("Mageskill_47.2cce9ac8.png").toString();